import aviva from "../images/aviva.png"
import aig from "../images/aig.png"
import lg from "../images/lg.png"
import rl from "../images/rl.png"
import zurich from "../images/zurich.png"
import lv from "../images/lv.png"

// insurance providers labels for rendering
export const providers = [
  {
    id: "1",
    src: aviva,
    alt: "Aviva",
  },
  {
    id: "2",
    src: aig,
    alt: "American International Group",
  },
  {
    id: "3",
    src: lg,
    alt: "Legal and General",
  },

  {
    id: "4",
    src: rl,
    alt: "Royal London",
  },
  {
    id: "5",
    src: zurich,
    alt: "Zurich",
  },
  {
    id: "6",
    src: lv,
    alt: "London Victoria",
  },
]
export default providers
